"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var _1 = require(".");

var svg_1 = require("./svg");

var styled_1 = __importDefault(require("@emotion/styled"));

var themes_1 = require("./themes");

var InfoButton = styled_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: none;\n  width: 20px;\n  height: 20px;\n  color: ", ";\n  margin-left: 10px;\n  background: transparent;\n  cursor: help;\n  line-height: 26px;\n  vertical-align: top;\n  outline: none;\n"], ["\n  border: none;\n  width: 20px;\n  height: 20px;\n  color: ", ";\n  margin-left: 10px;\n  background: transparent;\n  cursor: help;\n  line-height: 26px;\n  vertical-align: top;\n  outline: none;\n"])), function (props) {
  var _a, _b, _c, _d;

  return _d = (_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.colors) === null || _b === void 0 ? void 0 : _b.info) === null || _c === void 0 ? void 0 : _c.color, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.colors.info.color;
});
var InfoIcon = styled_1.default(svg_1.Help)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 20px;\n  height: 20px;\n  & path {\n    fill: ", ";\n  }\n"], ["\n  width: 20px;\n  height: 20px;\n  & path {\n    fill: ", ";\n  }\n"])), function (props) {
  var _a, _b, _c, _d;

  return _d = (_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.colors) === null || _b === void 0 ? void 0 : _b.info) === null || _c === void 0 ? void 0 : _c.color, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.colors.info.color;
});

exports.Info = function (_a) {
  var children = _a.children;

  var _b = react_1.useState(false),
      open = _b[0],
      setOpen = _b[1];

  return react_1.default.createElement(react_1.Fragment, null, react_1.default.createElement(InfoButton, {
    onClick: function onClick(e) {
      e.preventDefault();
      setOpen(true);
    }
  }, react_1.default.createElement(InfoIcon, null)), react_1.default.createElement(_1.Modal, {
    open: open,
    onClose: function onClose() {
      return setOpen(false);
    }
  }, react_1.default.createElement(_1.ModalBody, null, children)));
};

var templateObject_1, templateObject_2;